import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Inject, Injectable } from "@angular/core";

import { ENVIRONMENT } from "../token";

@Injectable()
export class Service {
	protected base_url: string = "";

	constructor(@Inject(ENVIRONMENT) protected environment, private http: HttpClient) {
		this.base_url = environment.api_url;
	}

	public apiGetWithHeaders(url: string, params: any): Observable<any> {
		params = this.parseCustomParams(params);
		return this.http.get(this.base_url + url, { withCredentials: true });
	}

	public apiGetWithHeaders1(url: string): Observable<any> {
		const headers = { responseType: "blob" };
		return this.http.get(this.base_url + url, { headers });
	}

	public apiGetWithoutHeaders(url: string, params: any): Observable<any> {
		params = this.parseCustomParams(params);
		return this.http.get(this.base_url + url + "?" + params, { withCredentials: true });
	}

	public apiGetWithoutParams(url: string): Observable<any> {
		return this.http.get(this.base_url + url, { withCredentials: true });
	}

	public getSingle(url: string, id: string): Observable<any> {
		return this.http.get(this.base_url + url + "/" + id, { withCredentials: true });
	}

	public apiGetBCClients(url: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: "Basic " + btoa("M793WS:Vt68vS5S"),
		});
		return this.http.get(url, { headers });
	}

	public apiPostExcel(url: string, body: any, params: any): Observable<any> {
		return this.http.post(this.base_url + url, body, {
			headers: {
				"Content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
			params: params,
			responseType: "blob" as "json",
			withCredentials: true,
		});
	}

	public apiPostReport(url: string, body: any, params: any): Observable<any> {
		return this.http.post(this.base_url + url, body, {
			headers: {
				"Content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
			params: params,
			responseType: "blob" as "json",
			withCredentials: true,
		});
	}

	public apiGetExcel(url: string, params: any): Observable<BlobPart> {
		return this.http.get<BlobPart>(this.base_url + url, {
			headers: {
				"Content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
			params: params,
			responseType: "blob" as "json",
			withCredentials: true,
		});
	}

	public apiPostExcelWithoutParams(url: string, body: any, params?: any): Observable<BlobPart> {
		return this.http.post<BlobPart>(this.base_url + url, body, {
			headers: {
				"Content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
			params,
			responseType: "blob" as "json",
			withCredentials: true,
		});
	}

	public apiPostWithoutHeaders(url: string, body: any): Observable<any> {
		return this.http.post(this.base_url + url, body, { withCredentials: true });
	}

	public apiPostUserRequest(url: string, body: any): Observable<any> {
		return this.http.post(url, body, { withCredentials: true });
	}

	public apiPut(url: string, body: any): Observable<any> {
		return this.http.put(this.base_url + url, body, { withCredentials: true });
	}

	public apiPutId(url: string, body: any, id: string): Observable<any> {
		return this.http.put(this.base_url + url + "/" + id, body, { withCredentials: true });
	}

	public apiDelete(url: string): Observable<any> {
		return this.http.delete(this.base_url + url, { withCredentials: true });
	}

	public apiPatchWithoutHeaders(url: string, body: any): Observable<any> {
		return this.http.put(this.base_url + url, body, {});
	}

	public parseCustomParams(params: any): string {
		let final_params: string[] = [];

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				if (Array.isArray(params[key])) {
					const array: Array<any> = params[key];
					if (array.length > 0) {
						array.forEach((element) => {
							final_params.push(`${key}=${element}`);
						});
					}
				} else if (this.isObject(params[key])) {
					for (const subKey in params[key]) {
						if (params[key].hasOwnProperty(subKey)) {
							final_params.push(`${key}[${subKey}]=${params[key][subKey]}`);
						}
					}
				} else {
					final_params.push(`${key}=${params[key]}`);
				}
			}
		}
		return final_params.join("&");
	}

	private isObject(value: any): value is Record<string, unknown> {
		return value !== null && typeof value === "object" && !Array.isArray(value);
	}
}
